export default __webpack_public_path__ + "static/media/content.7a382ec5.svg";